import { render, staticRenderFns } from "./TextPlaceholder.vue?vue&type=template&id=2beec17e&scoped=true"
import script from "./TextPlaceholder.vue?vue&type=script&lang=js"
export * from "./TextPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./TextPlaceholder.vue?vue&type=style&index=0&id=2beec17e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beec17e",
  null
  
)

export default component.exports